import { KeyValue } from "@/main/models/common";
import { PaginationResponse } from "@/main/models/common/paginationResponse";
import { Result } from "@/main/models/common/resultResponse";
import { RemoveQuoteItemRequest, CorrectCartItemPriceRequest } from "@/main/models/request";
import { OrderCancelRequest, OrderSaveRequest } from "@/main/models/request/orderRequest";
import {
	ApproveOrRejectQuoteRequest,
	DeleteImageQuoteRequest,
	GetAllClaimImagesResquest,
	GetItemsToRequoteRequest,
	GetQuoteItemRequest,
	ImportQuoteFileRequest,
	IndependentQuoteRequest,
	PreQuoteRequest,
	QuoteCheckoutRequest,
	QuoteCountStatusRequest,
	QuoteFilterRequest,
	QuoteGetItemsFilterRequest,
	QuoteRemoveQuoteItemRequest,
	QuoteSaveIntegrationRequest,
	QuoteSelectBestSupplierRequest,
	QuoteSelectSuppliersDataRequest,
	QuoteSendSuppliersZeroInventoryEmailRequest,
	QuoteXmlRequest,
	RequoteNationalRequest,
	RequoteRequest,
	SaveQuoteImagesRequest,
	SaveXmlPaintRequest,
	VehiclePartsAIImageRequest,
} from "@/main/models/request/quoteRequest";
import {
	CartResponseCount,
	ClaimDetailsResponse,
	GetItemsToRequoteResponse,
	GetQuoteItemResponse,
	ImportQuoteFileResponse,
	PreQuoteResponse,
	QuoteAwaitingApprovalResponse,
	QuoteAwaitingDetailResponse,
	QuoteCheckoutResponse,
	QuoteDataResponse,
	QuoteDirectAssignItemsResponse,
	QuoteGetItemConditionsWrapper,
	QuoteHeaderAnswerInformationResponse,
	QuoteImageResponse,
	QuoteManualChekoutResponse,
	QuoteResponse,
	QuoteResponseCount,
	QuoteSaveResponse,
	QuoteSelectBestSupplierResponse,
	QuoteSelectSuppliersDataResponseItems,
	QuoteTotalLossResponse,
	QuoteVehicleAIResponse,
	QuoteXmlResponse,
} from "@/main/models/response";
import { AxiosRequestConfig, AxiosResponse } from "axios";

export abstract class IQuoteApi {
	abstract saveQuote(request: OrderSaveRequest): Promise<AxiosResponse<Result<any>>>;

	abstract updateQuote(request: OrderSaveRequest): Promise<AxiosResponse<Result<any>>>;

	abstract saveIndependentQuote(request: IndependentQuoteRequest): Promise<AxiosResponse<Result<QuoteSaveResponse>>>;

	abstract getQuoteById(guidQuote: string): Promise<AxiosResponse<Result<QuoteResponse>>>;

	abstract cancelQuoteById(request: OrderCancelRequest): Promise<AxiosResponse<Result<any>>>;

	abstract getDomain(isUserControl?: boolean | null): Promise<AxiosResponse<Result<KeyValue[]>>>;

	abstract getSearchGrid(request: QuoteFilterRequest): Promise<AxiosResponse<PaginationResponse<QuoteDataResponse>>>;

	abstract countProcurementStatus(
		request: QuoteCountStatusRequest,
	): Promise<AxiosResponse<Result<QuoteResponseCount[]>>>;

	abstract getSummary(request: QuoteFilterRequest): Promise<AxiosResponse<PaginationResponse<QuoteDataResponse>>>;

	abstract getSelectBestSupplier(
		request: QuoteSelectBestSupplierRequest,
		config?: AxiosRequestConfig,
	): Promise<AxiosResponse<Result<QuoteSelectBestSupplierResponse>>>;

	abstract getItems(request: QuoteGetItemsFilterRequest): Promise<AxiosResponse<Result<QuoteGetItemConditionsWrapper>>>;

	abstract headeranswerinformation(
		guidQuote: string,
	): Promise<AxiosResponse<Result<QuoteHeaderAnswerInformationResponse>>>;

	abstract validateTotalLoss(guidQuote: string): Promise<AxiosResponse<Result<any>>>;

	abstract checkout(request: QuoteCheckoutRequest): Promise<AxiosResponse<Result<QuoteCheckoutResponse>>>;

	abstract buyNow(request: QuoteCheckoutRequest): Promise<AxiosResponse<Result<QuoteCheckoutResponse>>>;

	abstract getSelectSuppliers(
		request: QuoteSelectSuppliersDataRequest,
	): Promise<AxiosResponse<Result<QuoteSelectSuppliersDataResponseItems>>>;

	abstract getSupplierItems(
		guidQuoteItem: string,
	): Promise<AxiosResponse<Result<QuoteSelectSuppliersDataResponseItems>>>;

	abstract countCartStatus(request: QuoteCountStatusRequest): Promise<AxiosResponse<Result<CartResponseCount[]>>>;

	abstract getSendSuppliersZeroInventoryEmail(
		request: QuoteSendSuppliersZeroInventoryEmailRequest,
	): Promise<AxiosResponse<Result<void>>>;

	abstract saveIntegration(request: QuoteSaveIntegrationRequest[]): Promise<AxiosResponse<Result<void>>>;

	abstract saveIntegrationPDF(request: File[]): Promise<AxiosResponse<Result<void>>>;

	abstract getPreQuote(guidQuote: string): Promise<AxiosResponse<Result<PreQuoteResponse>>>;

	abstract savePreQuote(request: PreQuoteRequest): Promise<AxiosResponse<Result<boolean>>>;

	abstract getImportQuoteFile(
		request: ImportQuoteFileRequest,
	): Promise<AxiosResponse<Result<ImportQuoteFileResponse[]>>>;

	abstract getAllClaimImages(
		filter: GetAllClaimImagesResquest,
	): Promise<AxiosResponse<PaginationResponse<QuoteImageResponse>>>;

	abstract saveQuoteImages(request: SaveQuoteImagesRequest): Promise<AxiosResponse<Result<QuoteCheckoutResponse>>>;

	abstract deleteImageQuote(request: DeleteImageQuoteRequest): Promise<AxiosResponse<Result<boolean>>>;

	abstract importQuoteFiles(request: File[]): Promise<AxiosResponse<Result<boolean>>>;
	abstract getQuoteItem(request: GetQuoteItemRequest): Promise<AxiosResponse<Result<GetQuoteItemResponse>>>;

	abstract reQuote(guidQuote: string): Promise<AxiosResponse<Result<PreQuoteResponse>>>;

	abstract addMissingItemsToCart(guidQuote: string): Promise<AxiosResponse<Result<PreQuoteResponse>>>;

	abstract getClaimDetails(
		quoteGuid: string,
		guidScreen?: string,
	): Promise<AxiosResponse<Result<ClaimDetailsResponse>>>;
	abstract removeQuoteItem(
		request: QuoteRemoveQuoteItemRequest,
	): Promise<AxiosResponse<Result<QuoteGetItemConditionsWrapper>>>;

	abstract getItemsToRequote(
		request: GetItemsToRequoteRequest,
	): Promise<AxiosResponse<Result<GetItemsToRequoteResponse>>>;

	abstract requoteItems(request: RequoteRequest): Promise<AxiosResponse<Result<QuoteGetItemConditionsWrapper>>>;

	abstract requoteNationalItems(
		request: RequoteNationalRequest,
	): Promise<AxiosResponse<Result<QuoteGetItemConditionsWrapper>>>;
	abstract removeQuoteItems(
		request: RemoveQuoteItemRequest,
	): Promise<AxiosResponse<Result<QuoteGetItemConditionsWrapper>>>;
	abstract correctCartItemPrice(
		request: CorrectCartItemPriceRequest,
	): Promise<AxiosResponse<Result<QuoteGetItemConditionsWrapper>>>;

	abstract quoteXml(request: QuoteXmlRequest): Promise<AxiosResponse<Result<QuoteXmlResponse>>>;
	abstract saveXmlPaint(request: SaveXmlPaintRequest, file: File): Promise<AxiosResponse<Result<string>>>;

	abstract showStripePaymentButton(guidQuote: string): Promise<AxiosResponse<Result<boolean>>>;

	abstract updatePaymentPending(guidQuote: string): Promise<AxiosResponse<Result<boolean>>>;

	abstract changeQuoteToAwaitingRelease(guidQuote: string): Promise<AxiosResponse<Result<boolean>>>;

	abstract domainPreQuoteType(): Promise<AxiosResponse<Result<KeyValue[]>>>;

	abstract detailAwaiting(guidQuote: string): Promise<AxiosResponse<Result<QuoteAwaitingDetailResponse>>>;

	abstract getDirectAssignItems(guidQuote: string): Promise<AxiosResponse<Result<QuoteDirectAssignItemsResponse[]>>>;

	abstract getClaimDirectAssignItems(
		guidClaim: string,
	): Promise<AxiosResponse<Result<QuoteDirectAssignItemsResponse[]>>>;

	abstract getSuppliersForTotalLoss(
		request: QuoteSelectSuppliersDataRequest,
	): Promise<AxiosResponse<Result<QuoteSelectSuppliersDataResponseItems>>>;

	abstract getQuoteManualByGuidClaim(guidClaim: string): Promise<AxiosResponse<Result<QuoteManualChekoutResponse[]>>>;
	abstract getTotalLossByGuidQuote(guidQuote: string): Promise<AxiosResponse<Result<QuoteTotalLossResponse>>>;
	abstract getDetailsAwaitingApproval(guidQuote: string): Promise<AxiosResponse<Result<QuoteAwaitingApprovalResponse>>>;
	abstract approveOrRejectParts(request: ApproveOrRejectQuoteRequest): Promise<AxiosResponse<Result<boolean>>>;

	abstract expireDeadlineAnswer(guidQuote: string): Promise<AxiosResponse<Result<boolean>>>;
	abstract closeOfferRequest(guidQuote: string): Promise<AxiosResponse<Result<boolean>>>;

	abstract getVehiclePartsAIAssessment(
		images: VehiclePartsAIImageRequest[],
	): Promise<AxiosResponse<Result<QuoteVehicleAIResponse>>>;
}
